interface IProps {
  children: React.ReactNode;
}

const FAQMDListItem = ({ children }: IProps) => <li className="bsfq-li">{children}</li>;

export default FAQMDListItem;
